// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__Hqi-8","selected":"IconButton_selected__gWdRn","icon":"IconButton_icon__1I1JU","icon-selected":"IconButton_icon-selected__lvLXE"};